import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';
import { 
    getEdicaoCompleta,
    isInscricoesAbertas,
} from '../../helper/ContextHelper';

import Grid from '@material-ui/core/Grid';
import Alert from '@material-ui/lab/Alert'
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Box from '@material-ui/core/Box';
import { SearchOutlined } from '@material-ui/icons';

import CandidatoService from '../../services/Candidato';

import Title from '../../components/Title/Title';
import Toast from '../../components/Toast/Toast';
import Text from '../../components/Inputs/Text/Text';
import { LinkRegular, LinkFunction } from '../../components/Link/Link';

import ButtonsForm from '../../forms/Buttons/ButtonsForm';

import {
    isBlank,
    isBlankHelperText,
    isCPFHelperText,
    isCPFInvalid,
} from '../../helper/ValidationHelper';
import { numberMask } from '../../helper/MaskHelper';

import { handleLogin } from '../../security/keycloak';

import logo from '../../assets/img/logo.png';

import Layout from '../../layouts/public/Public';

export class List extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingButtonFind: false,
            loadingButtonSave: false,
            cpfParaBusca: '',
            cpf: null,
            isInscrito: false,
            isInscricaoFinalizada: false,
            errors: {
                cpfParaBusca: false,
            },
            helpers: {
                cpfParaBusca: null,
            },
        }
    }

    setToast = t => this.Toast = t;

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.name === 'cpfParaBusca' ? numberMask(e.target.value) : e.target.value,
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: false }
        });
    }

    handleSubmit = () => {
        if (!isInscricoesAbertas(this.props.contexts)) {
            this.Toast.setState({
                message: {
                    message: "Estamos Fora do Período de Inscrições. Aguarde uma Nova Abertura do Período de Inscrição.",
                    type: "error",
                    open: true
                }
            });
            return;
        }

        this.setState({ loading: true, loadingButtonFind: true });

        if (!this.isValid(this.state.cpfParaBusca)) {
            this.setState({ loading: false, loadingButtonFind: false });
            return;
        }

        CandidatoService.buscarInscricao(this.state.cpfParaBusca)
            .then(res => {
                if (res.status === 200) {
                    this.setState({
                        ...this.state,
                        cpf: this.state.cpfParaBusca,
                        isInscrito: true,
                        isInscricaoFinalizada: res.data.dataFinalizacaoInscricao ? true : false,
                    });
                } else if (res.status === 204) {
                    if (isInscricoesAbertas(this.props.contexts)) {
                        const cpf = this.state.cpfParaBusca;
                        this.props.history.push({ pathname: `/inscricao/${cpf}`, state: { history: { path: `/inscricao`, state: null, }}});
                    }
                }
            })
            .catch(error => {
                this.Toast.setState({
                    message: {
                        message: "Ocorreu um Problema ao Iniciar a Inscrição. Tente Novamente.",
                        type: "error",
                        open: true
                    }
                });
            })
            .finally(() => this.setState({ loading: false, loadingButtonFind: false }))
    }

    isValid = (cpfParaBusca) => {
        const blank = isBlank(cpfParaBusca);
        const invalid = isCPFInvalid(cpfParaBusca);

        if (blank || invalid) {
            this.setState({
                errors: {
                    cpfParaBusca: blank || isCPFInvalid(cpfParaBusca),
                },
                helpers: {
                    cpfParaBusca: blank ? isBlankHelperText() : isCPFInvalid(cpfParaBusca) ? isCPFHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    async componentDidMount() {
        await this.props.loadPeriodos();

        if (!isInscricoesAbertas(this.props.contexts)) {
            this.Toast.setState({
                message: {
                    message: "Ação de Iniciar Inscrição Inválida. Estamos Fora do Período de Inscrições. Aguarde Nova Abertura do Período de Inscrição.",
                    type: "error",
                    open: true
                }
            })

            setTimeout(() => this.props.history.push(`/`), 2000);
        }
    }

    render() {
        const page = `${this.props.contexts && getEdicaoCompleta(this.props.contexts)} - Inscrição de Professor`;

        return (
            <Layout>
                <Toast parentRef={this.setToast} />

                {this.props.contexts &&
                    <Container component="main" maxWidth="xl">
                        <Box mt={6}>
                            <div style={{ display: 'flex', alignItems: 'center', margin: 12 }}>
                                <img src={logo} style={{ margin: 12, marginRight: 24, height: '75px' }} alt={process.env.REACT_APP_NAME_GENERAL}/>
                                <Title>{page}</Title>
                            </div>

                            { (this.state.cpf && this.state.isInscrito) &&
                                <Grid item container spacing={3} align='center'>
                                    <Grid item sm={8} lg={8}>
                                        <Alert severity="warning">
                                            <Typography variant="h6" style={{ display: "flex" }}>
                                                {this.state.isInscricaoFinalizada ?
                                                    <>CPF com inscrição finalizada</>
                                                :
                                                    <>CPF com inscrição iniciada</>
                                                }
                                            </Typography>
                                            <Typography variant="body2" style={{ display: "flex" }}>
                                                {this.state.isInscricaoFinalizada ?
                                                    <>O CPF <b>&nbsp; {this.state.cpf} &nbsp;</b> já está inscrito na {getEdicaoCompleta(this.props.contexts)}.</>
                                                :
                                                    <>O CPF <b>&nbsp; {this.state.cpf} &nbsp;</b> está com a inscrição iniciada e não finalizada na {getEdicaoCompleta(this.props.contexts)}.</>
                                                }
                                            </Typography>
                                            <Typography variant="body2" style={{ display: "flex" }}>
                                                {this.state.isInscricaoFinalizada ?
                                                    <>Se você deseja fazer alguma alteração na ficha de inscrição,</>
                                                :
                                                    <>Para finalizar a inscrição,</>
                                                }
                                                <LinkFunction onClick={() => handleLogin(`${process.env.REACT_APP_PUBLIC_URL}/admin/inicial`)}>&nbsp; CLIQUE AQUI &nbsp;</LinkFunction> para efetuar login e ter acesso a sua ficha de inscrição.
                                            </Typography>
                                        </Alert>
                                    </Grid>
                                </Grid>
                            }

                            {(!this.state.cpf || (this.state.cpf && this.state.isInscrito)) &&
                                <>
                                    <Grid container spacing={3} align='center'>
                                        <Grid item sm={9} lg={9}>
                                            <Text
                                                autoFocus
                                                required
                                                name="cpfParaBusca"
                                                label="CPF do Professor (11 dígitos sem pontos e traços)"
                                                value={this.state.cpfParaBusca}
                                                error={this.state.errors.cpfParaBusca}
                                                onChange={this.handleChange}
                                                helperText={this.state.helpers.cpfParaBusca}
                                                inputProps={{ maxLength: 14 }}
                                            />
                                        </Grid>
                                        <Grid item sm={3} lg={3}>
                                            <ButtonsForm
                                                startIcon={<SearchOutlined />}
                                                onClick={this.handleSubmit}
                                                onBack={() => this.props.history.push({ pathname: "/" })}
                                                loading={this.state.loadingButtonFind}
                                                name={"Iniciar Inscrição"}
                                                nameOnBack={"Voltar"}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid item container spacing={3} align='center'>
                                        <Grid item sm={8} lg={8}>
                                            <Alert severity="info">
                                                <Typography variant="body2" style={{ display: "flex" }}>
                                                    O Professor, ao inscrever-se na {getEdicaoCompleta(this.props.contexts)}, concorda integralmente com todas as condições e regras previstas no
                                                    <LinkRegular to={{ pathname: "regulamento", state: { history: { path: `/inscricao`, state: null, } }}} > REGULAMENTO</LinkRegular>.
                                                </Typography>
                                            </Alert>
                                        </Grid>
                                    </Grid>
                                </>
                            }
                        </Box>
                    </Container>
                }
            </Layout>
        )
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(List));